import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CadastroUsuarioService } from "./api-CadastroUsuario.services";
import { UsuarioSignature } from "../../models/signature/UsuarioSignature";
import { AtualizaNovaSenhaSignature } from "../../models/signature/AtualizaNovaSenhaSignature";
import { ExcluirUsuarioSistemaSignature } from "../../models/signature/ExcluirUsuarioSistemaSignature";

@Injectable({
  providedIn: 'root'
})

export class CadastroUsuarioDataService {

  constructor(private api: CadastroUsuarioService) {
  }

  public GetListaUsuarios(): Observable<any> {
    return this.api.GetListaUsuarios();
  }

  public InsertUsuario(signature: UsuarioSignature): Observable<any> {
    return this.api.InsertUsuario(signature);
  }

  public UpdateUsuario(signature: UsuarioSignature): Observable<any> {
    return this.api.UpdateUsuario(signature);
  }

  public ResetSenhaUsuario(signature: UsuarioSignature): Observable<any> {
    return this.api.ResetSenhaUsuario(signature);
  }

  public JaExistCpfUsuario(signature: UsuarioSignature): Observable<any> {
    return this.api.JaExistCpfUsuario(signature);
  }

  public JaExistEmailUsuario(signature: UsuarioSignature): Observable<any> {
    return this.api.JaExistEmailUsuario(signature);
  }

  public UpdateNovaSenha(signature: AtualizaNovaSenhaSignature): Observable<any> {
    return this.api.UpdateNovaSenha(signature);
  }

  public ExcluirUsuarioSistema(signature: ExcluirUsuarioSistemaSignature): Observable<any> {
    return this.api.ExcluirUsuarioSistema(signature);
  }

}
